import Router from 'vue-routes-generator'
import Main from './Main'
import Listado from './components/listado/listado'
import Editor from './components/editor/editor.vue'
import Visualizar from './components/visualizar/visualizar.vue'

export default {
	install: () => {
		Router.route('/main').child('eventos', {
			name: 'Eventos',
			component: Main
		})

		Router.route('/main').child('eventos').child('', {
			name: 'Listado de eventos',
			component: Listado
		})

		Router.route('/main').child('eventos').child('editor', {
			name: 'Nuevo evento',
			component: Editor
		})

		Router.route('/main').child('eventos').child('editor/:id', {
			name: 'Editar evento',
			component: Editor
		})

		Router.route('/main').child('eventos').child('ver/:id', {
			name: 'Visualizar evento',
			component: Visualizar
		})
	}
}



// WEBPACK FOOTER //
// ./src/modulos/eventos/vue/index.js